import { render, staticRenderFns } from "./quizPop.vue?vue&type=template&id=b622434c"
import script from "./quizPop.vue?vue&type=script&lang=js"
export * from "./quizPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b622434c')) {
      api.createRecord('b622434c', component.options)
    } else {
      api.reload('b622434c', component.options)
    }
    module.hot.accept("./quizPop.vue?vue&type=template&id=b622434c", function () {
      api.rerender('b622434c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/quiz/quizPop.vue"
export default component.exports